import { useEffect, useState } from "react";
import ActionButton from "./action-button";
import ButtonsGroup from "./buttons-group";
import FormValidating from "./form-validating";
import Panel from "./panel";

const STORAGE_KEY = "search-panel-prefs";
export type FormValues = Record<string, string>;

export function getPrefs(def: Record<string, string> = {}): FormValues {
  return {
    ...def,
    ...JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? "{}")
  } as FormValues;
}
export function getPref(key: string, def: string): string {
  return getPrefs({ [key]: def })[key] ?? def;
}

export default function SearchPanel(props: {
  form?: React.ReactNode;
  onSearch: (data: FormValues) => Promise<React.ReactNode | null>;
}): React.ReactNode {
  const [result, setResult] = useState<React.ReactNode | null>(null);

  const onSearch = (formData: FormData) => {
    setResult(null);
    const data = Object.fromEntries(
      formData.entries().filter(([key, value]) => value !== "")
    ) as FormValues;

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...getPrefs(),
        ...data
      })
    );

    return props.onSearch(data).then((data) => setResult(data ?? []));
  };

  useEffect(() => {
    if (!props.form && result === null) {
      onSearch(new FormData());
    }
  });

  return (
    <div className="search-panel">
      {props.form && (
        <>
          <Panel fixed label="Filters" testid="search-panel-form">
            <FormValidating action={onSearch}>
              {props.form}
              <ButtonsGroup className="mt-3">
                <ActionButton style="Confirm" type="submit" action="Search" />
              </ButtonsGroup>
            </FormValidating>
            {result === null && (
              <div className="alert alert-info">Please fill in the form</div>
            )}
          </Panel>
          <hr />
        </>
      )}
      {result != null && (
        <>
          {props.form && (
            <>
              <h1>Results</h1>
              {result}
            </>
          )}
        </>
      )}
    </div>
  );
}
